export const humanityDescriptionArray = [
  'Nosso foco será sempre no impacto positivo que nossas ações e trabalhos geram.',
  'Possui autonomia na gestão do seu trabalho. Sabe o que deve fazer e não precisa estar sendo cobrado.',
  'Demonstra vontade de aprender e crescer, encarando novas situações como oportunidades de aprendizado.',
];

export const managementDescriptionArray = [
  'Suporte do fluxo de valor e melhorias do negócio.',
  'Conjunto de valores e práticas que enfatizam a flexibilidade, a colaboração, a adaptação e a entrega contínua de valor proporcionando aprendizado e adaptações rápidas às mudanças.',
  'Está sempre atualizado sobre as tendências, futuro e seus impactos na sociedade e na sua área de atuação.',
];

export const leaderDescriptionArray = [
  'Mantém o equilíbrio emocional em situações adversas.',
  'Demonstra autodisciplina e autodirecionamento sabendo trabalhar em time.',
  'É uma pessoa sempre atenta e em busca de novas oportunidades e ideias dentro da empresa.',
];
